module.exports = __webpack_public_path__ + "static/media/yearn__bg--pattern--blueonwhite--light.b5d83dde.png";